import { render, staticRenderFns } from "./UniDetailAbout.vue?vue&type=template&id=c3c60332&scoped=true&"
import script from "./UniDetailAbout.vue?vue&type=script&lang=js&"
export * from "./UniDetailAbout.vue?vue&type=script&lang=js&"
import style0 from "./UniDetailAbout.vue?vue&type=style&index=0&id=c3c60332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c60332",
  null
  
)

component.options.__file = "UniDetailAbout.vue"
export default component.exports